/* eslint camelcase:0 */
var request_config = {
    appDomain: 'api.beta.allfootballapp.com',
    apiDomain2: 'api.allfootballapp.com',
    apiDomain3: 'article.allfootballapp.com',

    // 生产环境
    staticDomain: 'allfootball-static.dongqiudi.com/node',
    apiDomain: 'm-api.allfootballapp.com',
    apiYinniDomain: 'match.allfootballapp.com',

    // ! beta 环境
    // staticDomain: 'allfootball-static.dongqiudi.com/node',
    // apiDomain: 'beta-m-api.allfootballapp.com',
    // apiYinniDomain: 'beta-match.allfootballapp.com',
};

module.exports = {
    appDomain: 'https://' + request_config.appDomain,
    apiDomain: 'https://' + request_config.apiDomain,
    staticDomain: 'https://' + request_config.staticDomain,
    apiDomain2: 'https://' + request_config.apiDomain2,
    apiDomain3: 'https://' + request_config.apiDomain3,
    apiYinniDomain: 'https://' + request_config.apiYinniDomain,
};



//////////////////
// WEBPACK FOOTER
// ./bin/config.js
// module id = 82
// module chunks = 16